import { useAuthSelector } from 'app/data/auth';
import templateQueryKeys from 'app/hooks/queries/template/templateQueryKeys';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { TemplatesPageResponse } from 'types/template';

export const useListTemplatesQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of templates
  // - just get ALL templates+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = templateQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<TemplatesPageResponse, Error>(
    queryKey,
    () =>
      sdk.template.query.templates(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListTemplatesQuery;
